import type { LookoRouteObject } from '@/router/LookoRouteObject';

export const 원스톱_솔루션_설정_라우터 = {
  setting: {
    path: '/settings/one-stop-solution',
    async lazy() {
      const { default: Page } = await import('@/router/settings/one-stop-solution/원스톱_솔루션_신청_페이지');
      return {
        Component: Page,
      };
    },
    handle: {
      title: '원스톱 솔루션 신청',
      displayInSidebarMenu: true,
    },
  } satisfies LookoRouteObject,
};

export const 원스톱_솔루션_설정_라우터_루트 = Object.values(원스톱_솔루션_설정_라우터);
